import React from "react";
import Seo from "components/Seo";
import CompanyLayout from "./companyLayout";
import CI from "../../../common/-pages/company/ci";

const MorningCI = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="CI소개" />
            <CompanyLayout>
                <CI />
            </CompanyLayout>
        </React.Fragment>
    );
};

export default MorningCI;
